import { Alert, Button } from "@assetwatch/ui";

/** Why the side sheet is explaining that AI assistance did not help. Either
 * way the user is on the Form tab, where the notice stays visible:
 * - unavailable: the model could not be used (the intake API reported it
 *   unavailable, or the request failed, timed out, or returned 5xx);
 * - incomplete: the chat could not produce a draft complete enough to review. */
export type AiNotice = "unavailable" | "incomplete";

const AI_NOTICE_TITLES: Record<AiNotice, string> = {
  unavailable:
    "AI assistance is unavailable right now. You can continue with the form.",
  incomplete:
    "AI assistance couldn't complete the request. Finish the details in the form.",
};

export function AiNoticeAlert({
  notice,
  onContinue,
}: {
  notice: AiNotice;
  onContinue?: () => void;
}) {
  return (
    <Alert
      action={
        onContinue ? (
          <Button onClick={onContinue} size="sm" variant="outline">
            Continue with form
          </Button>
        ) : undefined
      }
      title={AI_NOTICE_TITLES[notice]}
      tone="warning"
    />
  );
}
